module.exports = __webpack_public_path__ + "img/48.914046aa.png";